import { TenantBrandItem } from "../../../../../Brands"
import { useParams } from "../../../../../router-utils"

export default function ProfileDetails() {
	const { id } = useParams("/org/profile/:id")
	return <TenantBrandItem brandId={id} />
}
